<template>
  <Layout :page="'Chỉnh sửa thông tin chung'" @submit="submit = $event">
      <ValidationObserver ref="observerItems">
        <b-form @submit.stop.prevent>
          <LayoutCard>
            <LayoutCardTitle>Thông tin cơ bản </LayoutCardTitle>

            <LayoutFieldSet>
              <LayoutField :required="true">
                <template #label>Tên sản phẩm</template>
                <template #input>
                  <BaseInput
                    :placeholder="'Nhập tên sản phẩm'"
                    v-model="Item.name"
                    :name="'Tên sản phẩm'"
                    :rules="'required|lBetween:3,255|CHECK_HTML'"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet>
              <LayoutField>
                <template #label> Đơn vị tính</template>
                <template #input>
                  <BaseSelect
                    v-model="Item.unit.name"
                    :options="dataUnit"
                    :label="'unitName'"
                    :placeholder="'Chọn đơn vị tính'"
                    @select="getValueUnit($event)"
                    :showADD="true"
                  >
                    <template #showADD>
                      <div
                        @click="isPopupAddUnit = true"
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm đơn vị tính
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>
              <LayoutField>
                <template #label>Khối lượng</template>
                <template #input>
                  <BaseInput
                    :unit="'gr'"
                    v-model="Item.weightInGram"
                    :type="'unit'"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet>
              <LayoutField v-if="!showNote">
                <template #input>
                  <div class="box-dashed" @click="showNote = true">
                    <i class="fa-solid fa-plus"></i>
                    <span>Thêm mô tả sản phẩm</span>
                  </div>
                </template>
              </LayoutField>

              <LayoutField v-else>
                <template #label>Mô tả</template>
                <template #input>
                  <BaseTextarea
                    :value="Item.description"
                    @value="Item.description = $event"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>
          </LayoutCard>
          
          <LayoutCard>
            <LayoutCardTitle>Phân loại </LayoutCardTitle>

            <LayoutFieldSet>
              <LayoutField>
                <template #label>Danh mục</template>
                <template #input>
                  <BaseSelect
                    :options="dataCategory"
                    v-model="Item.metaSearchable.category"
                    label="name"
                    @select="getListCategorySub($event)"
                    :hideRemove="true"
                    placeholder="Chọn danh mục"
                    :showADD="true"
                  >
                    <template #showADD>
                      <div
                        @click="isPopupAddCategory = true"
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm nhanh danh mục
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>
              <LayoutField>
                <template #label>Danh mục con</template>
                <template #input>
                  <BaseSelect
                    v-model="Item.categorySub"
                    :options="dataCategorySub"
                    :label="'name'"
                    placeholder="Chọn loại sản phẩm"
                    @select="getValueCategorySub($event)"
                    :hideRemove="true"
                    :showADD="(Item.metaSearchable.category !== '') ? true : false"
                  >
                    <template #showADD>
                      <div
                        @click="isPopupAddCategorySub = true"
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm nhanh loại sản phẩm
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet>
              <LayoutField>
                <template #label>Thương hiệu</template>
                <template #input>
                  <BaseSelect
                    :options="dataBrands"
                    :label="'brandName'"
                    placeholder="Chọn thương hiệu"
                    v-model="Item.metaSearchable.brand"
                    @select="Item.metaSearchable.brand = $event.text"
                    :showADD="true"
                  >
                    <template #showADD>
                      <div
                        @click="isPopupAddBrand = true"
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm thương hiệu
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>

              <LayoutField>
                <template #label>Bảo hành</template>
                <template #input>
                  <BaseSelect
                    v-model="Item.warranty.warrantyName"
                    :options="dataWarranty"
                    :label="'warrantyName'"
                    placeholder="Chọn bảo hành"
                    @select="getValueWarranty($event)"
                    :showADD="true"
                  >
                    <template #showADD>
                      <div
                        @click="isPopupAddWarranty = true"
                        style="color: #3E69F6; cursor: pointer; font-weight: bold;padding: 12px 16px;"
                      >
                        Thêm bảo hành
                      </div>
                    </template>
                  </BaseSelect>
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet v-if="activeStatusByMerchant || useProductBatch">
              <LayoutField style="flex: 0 0 100%;">
                <template #label>Hình thức quản lý</template>
                <template #input>
                  <div class="field_check_box">
                    <div class="check_box">
                      <BaseCheckbox
                        type="radio"
                        v-model="Item.metaSearchable.statusDefault"
                        :disabled="true"
                        id="statusDefault"
                      />
                      <div style="color: #3e69f6">Sản phẩm thường</div>
                    </div>

                    <div class="check_box">
                      <BaseCheckbox
                        type="radio"
                        v-model="Item.metaSearchable.statusImei"
                        id="statusImei"
                        :disabled="true"
                      />
                      <div style="color: #3e69f6">Sản phẩm EMEI/Serial</div>
                    </div>
                    <div class="check_box">
                      <BaseCheckbox
                        type="radio"
                        v-model="Item.metaSearchable.statusBatch"
                        id="statusBatch"
                        :disabled="true"
                      />
                      <div style="color: #3e69f6">Sản phẩm có HSD</div>
                    </div>
                  </div>
                </template>
              </LayoutField>
            </LayoutFieldSet>

          </LayoutCard>

          <LayoutCard>
            <LayoutCardTitle>Hình ảnh</LayoutCardTitle>

            <LayoutFieldSet>
              <LayoutField>
                <template #label>Hình ảnh đại diện</template>
                <template #input>
                  <ItemSelectImage
                    :list="listImages"
                    :value="avatar"
                    @value="avatar.images = $event"
                  />
                  
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutFieldSet>
              <LayoutField>
                <template #label>Hình ảnh sản phẩm</template>
                <template #input>
                  <BaseUploadImage
                    :value="listImages"
                    @value="listImages = $event"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>
          </LayoutCard>
        </b-form>
      </ValidationObserver>

      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>

      <PopupAddUnit
        :isPopup="isPopupAddUnit"
        @getValue="getValueUnit($event, 'add-new')"
      />

      <PopupAddBrand
        :isPopup="isPopupAddBrand"
        @getValue="getValueBrand($event)"
      />

      <PopupAddWarranty
        :isPopup="isPopupAddWarranty"
        @getValue="getValueWarranty($event, 'add-new')"
      />

      <PopupAddCategory
        :isPopup="isPopupAddCategory"
        @getValue="getListCategorySub($event, 'add-new')"
      />

      <PopupAddCategorySub
        :isPopup="isPopupAddCategorySub"
        :category="categoryTmp"
        :listCategory="dataCategory"
        @getValue="getValueCategorySub($event, 'add-new')"
      />

  </Layout>
</template>

<script>
import moment from "moment";
import Swal from "sweetalert2";
import Layout from "@/router/layouts/item";
import ItemOption from "@/pages/items/components/ItemOption.vue";
import ItemSelectImage from "@/pages/items/components/ItemSelectImage.vue";
import PopupAddUnit from "@/components/popup-add-quick/popup-add-unit.vue";
import PopupAddBrand from "@/components/popup-add-quick/popup-add-brand.vue";
import PopupAddWarranty from "@/components/popup-add-quick/popup-add-warranty.vue"
import PopupAddCategory from "@/components/popup-add-quick/popup-add-category.vue"
import PopupAddCategorySub from "@/components/popup-add-quick/popup-add-categorysub.vue"

import formatNumber from "@/mixins/items/formatNumber";
import getListUnit from "@/mixins/items/getListUnit";
import getListBrand from "@/mixins/items/getListBrand";
import getListWarranty from "@/mixins/items/getListWarranty";
import getListInventory from "@/mixins/items/getListInventory";
import getListLocation from "@/mixins/items/getListLocation";
//import getDetailItem from "@/mixins/items/getDetailItem";
import getDetailItemCompound from "@/mixins/items/getDetailItem";
import activeImeiByMerchant from "@/mixins/items/activeImeiByMerchant";

import { CategoryService } from "@/services/nextshop/category.service";
import { ProductService } from "@/services/nextshop/product.service";
import { inventoryItem, inventoryItemLoHsd } from '@/utils/fieldsTable.js'

import { categoryGetList } from '@/api/category';

export default {
  components: {
    Layout,
    ItemOption,
    ItemSelectImage,
    PopupAddUnit,
    PopupAddBrand,
    PopupAddWarranty,
    PopupAddCategory,
    PopupAddCategorySub,
  },

  mixins: [
    getListUnit,
    getListBrand,
    getListWarranty,
    getListInventory,
    getListLocation,
    //getDetailItem,
    getDetailItemCompound,
    formatNumber,
    activeImeiByMerchant,
  ],

  data() {
    return {
      isShowOut: false,
      showNote: false,
      submit: false,
      showTableVariations: false,
      showTableVariationsTmp: false,
      loading: false,
      activeStatusByMerchant: false,
      isPopupAddUnit: false,
      isPopupAddBrand: false,
      isPopupAddWarranty: false,
      isPopupAddCategory: false,
      isPopupAddCategorySub: false,
      categoryTmp: {},
      fieldsInventory: inventoryItem,
      dataUnit: [],
      dataBrands: [],
      dataWarranty: [],
      dataCategory: [],
      dataCategorySub: [],
      rootCateId: '',
      avatar: {
        nameOption: "Phien-ban-goc",
        images: [],
      },
      listImages: [],
      Item: {
        name: "",
        unit: "",
        weightInGram: 0,
        categoryId: "",
        metaSearchable: {
          brand: "",
          isSelling: false,
          category: "",
          statusDefault: false,
          statusImei: false,
          statusBatch: false
        },
        validate: {
          sku: "",
          upc: "",
        },
        description: "",
        images: [],
        options: [],
        sku: "",
        upc: "",
        tags: [],
        unit: {
          name: "",
          additionalUnits: [],
        },
        variations: [],
        selected: false,
        priceItem: [
          {
            exportPrice: 0,
            importPrice: 0,
          },
        ],
        warranty: {
          description: "",
          dueAtInMinute: "3021-01-26T20:14:52.036Z",
          duration: 0,
          timeUnit: "",
          warrantyName: "",
        },
      },
      useProductBatch: true
    };
  },

  async created() {
    try {
      this.loading = true;

      
      this.dataUnit = await this.getListUnit();
      this.dataBrands = await this.getListBrand();
      this.dataWarranty = await this.getListWarranty();
      this.getCategorys();
      this.activeStatusByMerchant = await this.activeImeiByMerchant();
      await this.getDataItem();

      let resul = this.dataCategory.find(
        (e) => e.name === this.Item.metaSearchable.category
      );

      if (typeof resul != "undefined") {
        resul = {
          ...resul,
          text: resul.name,
        };
        this.getListCategorySub(resul);
      }

      // check type item: set fields show
      if(this.Item.metaSearchable.statusBatch){
        this.fieldsInventory = inventoryItemLoHsd
      }else{
        this.fieldsInventory = inventoryItem
      }

      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    
    async getDataItem() {
      try {
        // const response = await this.getDetailItem(this.$route.params.id);
        const params = {itemId: this.$route.params.id }
        const response = await this.getDetailItemCompound(params);

        let useBatch = response?.metaSearchable.useProductBatch === "true"
        if (response) {
          this.Item = {
            ...response,
            variations: response.variations.map(vari => {
              return {
                ...vari,
                variations: response.variations
              }
            })
          }
        }
        this.Item.categorySub = this.Item.category.name
        if (this.Item.images[0] != "") {
          this.avatar.images.push(this.Item.images[0]);
        }
        this.Item.images.map((e, index) => {
          if (index != 0) {
            this.listImages.push(e);
          }
        });


        this.showTableVariationsTmp =
          this.Item.options.length;
        this.showTableVariations = this.Item.options.length > 0;
        this.showNote = this.Item.description != "";

        if (useBatch) {
          this.Item.metaSearchable.statusBatch = true
          this.Item.metaSearchable.statusDefault = false
          this.Item.metaSearchable.statusImei = false
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getListCategorySub(value, type) {
      this.rootCateId = value.id
      try {
        if (value != null) {
          this.Item.metaSearchable.category = value.text;
          this.categoryTmp = value
          this.Item.categorySub = "";
          this.Item.categoryId = "";
          this.dataCategorySub = [];
          if (value.text != "") {
            const params = {
              queryString: { parentId: { eq: value.id } },
              sort: "-id",
              lastItem: "",
              limit: 100,
            };
            const response = await CategoryService.getList(params);
            if (response.success) {
              this.dataCategorySub = response.data;
              const resul = this.dataCategorySub.find(
                (e) => e.id == this.Item.categoryId
              );
              if (typeof resul != "undefined") {
                this.Item.categorySub = resul.name;
              } else {
                this.Item.categorySub = "";
              }
            }
          }
          if (type === 'add-new') {
            this.dataCategory.unshift(value)
          }
        }

        this.isPopupAddCategory = false
      } catch (error) {
        console.log(error);
      }
    },

    getValueCategorySub($event, type) {
      this.isPopupAddCategorySub = false
      if ($event != null ) {
        if ($event.name != '') {
          const dataTmp = this.dataCategorySub
          this.dataCategorySub = [];
          this.Item.categoryId = $event.id;
          this.dataCategorySub = dataTmp
          this.Item.categorySub = $event.text;
        }

        if (type === 'add-new') {
          this.dataCategorySub.unshift($event)
        }
      }
    },

    getValueWarranty($event, type) {
      this.isPopupAddWarranty = false
      if ($event != null ) {
        if ($event.warrantyName != "") {
          let date =
            $event.unit === "NGAY"
              ? new Date(
                  moment().endOf("day").add($event.warrantyPeriod, "days")._d
                ).toISOString()
              : $event.unit === "THANG"
              ? new Date(
                  moment().endOf("month").add($event.warrantyPeriod, "months")._d
                ).toISOString()
              : new Date(
                  moment().endOf("years").add($event.warrantyPeriod, "years")._d
                ).toISOString();

          this.Item.warranty.duration = $event.warrantyPeriod;
          this.Item.warranty.timeUnit = $event.unit;
          this.Item.warranty.description = $event.warrantyName;
          this.Item.warranty.warrantyName = $event.warrantyName;
          this.Item.warranty.dueAtInMinute = date;
        }
        if (type == 'add-new') {
          this.dataWarranty.unshift($event)
        }
      } else if ($event == null) {
        return
      } else {
        this.Item.warranty = {
          description: "",
          dueAtInMinute: "3021-01-26T20:14:52.036Z",
          duration: 0,
          timeUnit: "",
          warrantyName: "",
        };
      }
    },

    getCategorys() {
      const req = {
        queryString: { parentId: { eq: "" } },
        sort: "-id",
        lastItem: "",
        limit: 100,
      }
      categoryGetList(req).then(res => {
        this.dataCategory = res.data
      })
    },

    getValueBrand(data) {
      this.isPopupAddBrand = false
      if (data !== null) {
        if (data.brandName != '') {
          this.dataBrands.unshift(data),
          this.Item.metaSearchable.brand = data.brandName
        }
      }
    },

    getValueUnit(data, type) {
      this.isPopupAddUnit = false
      if (data !== null) {
        if (data.unitName != '') {
          this.Item.unit.name = data.unitName
        }

        if (type == 'add-name') {
          this.dataUnit.unshift(data)
        }
      }
    },

    async updateItem() {
      this.loading = true;
      this.Item.variations.map(item => {
        item.weightInGram = this.Item.weightInGram
        item.name = this.Item.name
        if(item.variations && item.variations.length == 1){
          item.variations[0].name = this.Item.name
        }
      })
      this.Item.images = [];
        if (this.avatar.images.length > 0) {
          this.Item.images.push(this.avatar.images[0]);
        } else {
          this.Item.images.push("");
        }
      this.listImages.map((e) => this.Item.images.push(e))
      let variations = []
      if(this.Item.variations.length > 1){
        variations = this.Item.variations.map(variant => {
          return {
            ...variant,
            name: `${this.Item.name}-${variant.nameOption}`
          }
        }) 
      }else{
        variations = this.Item.variations.map(variant => {
          return {
            ...variant,
            name: `${this.Item.name}`
          }
        }) 
      }
      const params = {
        itemReq :
          {
            id: this.Item.id,
            name: this.Item.name,
            categoryId: this.Item.categoryId,
            metaSearchable: {
              rootCateId: this.rootCateId ? this.rootCateId : this.Item.metaSearchable.rootCateId,
              brand: this.Item.metaSearchable.brand,
              category: this.Item.metaSearchable.category,
              ...(this.Item.metaSearchable.statusImei && {useImeiAndSerial: "true"}),
              ...(this.Item.metaSearchable.statusBatch && {useProductBatch: "true"}),
              statusDefault: this.Item.metaSearchable.statusDefault,
            },
            variations: variations,
            description: this.Item.description,
            images: this.Item.images,
            unit: {
              additionalUnits: [],
              name: this.Item.unit.name != "" ? this.Item.unit.name : "Cái",
            },
            warranty: this.Item.warranty,
            optimisticVersion: this.Item.version
          }
      }
      const response = await ProductService.updateItem(params);
      this.loading = false;
      Swal.fire({
        icon: "success",
        title: 'Thành công',
        text: 'Cập nhật sản phẩm thành công',
        confirmButtonText: "Xác nhận",
      }).then(() => {
        this.$router.push(`/items/items-detail/${this.$route.params.id}`);
      });
    }

  },

  watch: {
    submit() {
      this.updateItem()
    }
  },
};
</script>

<style lang="scss" scoped>
.box-dashed {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px;
  font-weight: 500;
  font-size: 14px;
  border: 1px dashed #9eb4fa;
  border-radius: 4px;
  background-color: #fff;
  color: #3e69f6;
  cursor: pointer;
  i {
    padding-right: 5px;
  }
}


.isSelling {
  display: flex;
  align-items: center;
  height: 100%;

  & > *:not(*:first-child) {
    margin-left: 10px;
  }
}

.field_check_box {
  display: flex;
  align-self: center;

  .check_box {
    display: flex;
    margin-right: 30px;
  }
}

::v-deep .upc-input {
  .__wrap {
    width: 224px;

    .__input {
      text-transform: uppercase;
    }
  }
}
.text-head-modal{
    color: #000;
    font-size: 15px;
    line-height: 20px;
    text-align: left;
    background: #f0f0f0;
    padding: 8px 10px;
  }
  .text-head-active{
    text-align: center;
    width: 90%;
    margin: 0 auto;
  }
  .text-des-active{
    text-align: center;
    width: 90%;
    margin: 0 auto;
  }
  .box-modals .btn {
    margin: 0 5px;
  }
  .line-active{
    border-top: 1px solid #ddd;
    padding-top: 12px;
  }
  .btn-closed{
    padding:10px 15px;
  }
  .arrTabs{
    display:inline-block;
    width: 100%;
  }
  .arrTabs li{
    display:inline-block;
    font-weight: bold;
    font-size: 20px;
    color: #a7acb1;
    cursor: pointer;
  }
  .arrTabs li.active{
    color: #23313E;
  }
  .card_wall{
    border-left: 2px solid #B9B9B9;
    margin: 0px 20px;
    display: inline-block;
    height: 22px;
    position: relative;
    top: 5px;
  }
</style>
